import qs from 'qs';
import request from '../utils/request';

// 今日统计
export const todayStatistic = () => request('/admin/statistic/today');
// 历史统计
export const historyStatistic = (params) => request(`/admin/statistic/history?${qs.stringify(params)}`);
// 排行
export const stationRange = (params) => request(`/admin/statistic/range?${qs.stringify(params)}`);
// 数据报表
export const dialyreport = (params) => request(`/admin/statistic/dailyreport?${qs.stringify(params)}`);
// 月报
export const monthReport = (id, params) => request(`/admin/statistic/month-report/${id}?${qs.stringify(params)}`);
// 月报数据导出
export const monthReportExport = (id, params) => request(`/admin/statistic/month-report/export/${id}?${qs.stringify(params)}`);
